import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    InputAdornment,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/Close";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {useSubscriptionActions} from "../../../service/useSubscriptionActions";
import {formatDate, intToFloatCurrency, stringToBool} from "../../../component/Utils";
import {useLookupActions} from "../../../service/useLookupActions";
import AcrissMonthlyFeeTable from "../components/AcrissMonthlyFeeTable";
import { useRecoilState } from "recoil";
import { LOADING } from "../../../service/SalesMarketingRecoil";
import * as React from "react";


const SubscriptionDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'subscription'});
    const theme = useTheme();
    const {globalData} = useContext(GlobalContext);
    const {subscription} = props;
    const {getProductCodes} = useSubscriptionActions();
    const [product, setProduct] = useState<any>({});
    const [dmsList, setDmsList] = useState<any[]>([]);
    const [acrisExt,setAcrisExt] = useState({} as Record<string, number>)
    const {getRatePlanInfoByProductCode} = useLookupActions();
    const [_,setIsLoading] = useRecoilState(LOADING);
    const [visitedSubscriptionId,setVisitedSubscriptionId] = useState<number | null>(null)

    useEffect(() => {
        if(subscription) {
            setVisitedSubscriptionId(subscription.id)
            if(visitedSubscriptionId && visitedSubscriptionId !== subscription.id){
                setAcrisExt({});
                setProduct({});
                setDmsList([])
            }
        }
    },[subscription])

    useEffect(() => {
        if (subscription && subscription.productCode) {
                Promise.allSettled([
                    getProductCodes(undefined, subscription.productCode,true),
                    getRatePlanInfoByProductCode(subscription.productCode,true)
                ]).then((results) => {
                    setIsLoading(false)
                    const productResult = results[0];
                    const ratePlanResult = results[1];

                    if (productResult.status === 'fulfilled') {
                        const product = productResult.value.result.content[0];
                        setProduct(product);
                    }

                    if (ratePlanResult.status === 'fulfilled') {
                        const res = ratePlanResult.value;
                        setDmsList(res.locationsExt);
                        setAcrisExt(res.acrisExt);
                    }
                });
           
           /*  getProductCodes(undefined, subscription.productCode).then((res: any) => {
                setProduct(res.result.content[0]);
            });
            getRatePlanInfoByProductCode(subscription.productCode).then((res: any) => {
                setDmsList(res.locationsExt);
                setAcrisExt(res.acrisExt)
            }) */
        }
    }, [subscription]);

    console.log({acrisExt});

    const onDialogClose = () => {
        props.handleClose()
    }


    return (subscription && product && dmsList &&
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('details.title')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container rowSpacing={3} columnSpacing={3}>
                    {(globalData?.user?.legalEntities?.length > 1 || globalData?.user?.dealers?.length > 1) &&
                        < Grid container item xs={12} spacing={1}>
                            {globalData?.user?.legalEntities?.length > 1 &&
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        label={t('form.legalEntityField')}
                                        value={subscription.tenantId}
                                        margin="dense"
                                        variant="standard"
                                        inputProps={
                                            {readOnly: true}
                                        }
                                    >
                                    </TextField>
                                </Grid>
                            }
                            {globalData?.user?.dealers?.length > 1 &&
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        label={t('form.dealerField')}
                                        value={subscription.dealerId}
                                        margin="dense"
                                        variant="standard"
                                        inputProps={
                                            {readOnly: true}
                                        }
                                    >
                                    </TextField>
                                </Grid>
                            }
                        </Grid>
                    }
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.status')}
                            value={t('statuses.' + subscription.status)}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.name')}
                            value={subscription.name}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.id')}
                            value={subscription.id}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.category')}
                            value={subscription.category}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.productName')}
                            value={product.name || ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.totalRate')}
                            value={subscription.totalRate || ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    {subscription.category === 'Flex Rent' && <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.flexRentType')}
                            value={subscription.flexRentType || ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>  }
                    {subscription.category !== 'Flex Rent' && <Grid item xs={3}/> }
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.productCode')}
                            value={subscription.productCode || ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.productDescription')}
                            value={product.description || ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.productStartDate')}
                            value={product.startDate ? formatDate(product.startDate) : ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.productEndDate')}
                            value={product.endDate ? formatDate(product.endDate) : ' '}
                            margin="dense"
                            variant="standard"
                            inputProps={{
                                readOnly: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.createdDate')}
                            value={subscription.createdDate ?  formatDate(subscription.createdDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            label={t('form.lastModifiedDate')}
                            value={subscription.lastModifiedDate ?  formatDate(subscription.lastModifiedDate) : '--' }
                            margin="dense"
                            variant="standard"
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item container xs={9} rowSpacing={3} columnSpacing={3}>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('form.priority')}
                                value={subscription.priority}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('form.sku')}
                                value={subscription.sku}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('form.dms')}
                                value={subscription && dmsList.length > 0 ? subscription.pickupDms.map((l: any) => dmsList.find((ll: any) => ll.sapId === l)?.name).join(', ') : []}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('form.startDate')}
                                value={subscription.activableStartDate ? formatDate(subscription.activableStartDate)  : ''}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('form.endDate')}
                                value={subscription.activableEndDate ? formatDate(subscription.activableEndDate)  : ''}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label={t('form.entryFee')}
                                value={intToFloatCurrency(subscription.entryFee.toString())}
                                margin="dense"
                                variant="standard"
                                inputProps={{
                                    readOnly: true
                                }}
                            />
                        </Grid>
                    {(subscription.category === 'CarCloud' || subscription.category === 'BE FREE EVO') &&
                        <>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label={t('form.startRenewalDay')}
                                    value={subscription.startRenewalDay}
                                    InputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label={t('form.endRenewalDay')}
                                    value={subscription.endRenewalDay}
                                    InputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label={t('form.discount')}
                                    value={subscription.annualRenewalDiscount}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                        readOnly: true
                                    }}
                                />
                            </Grid>
                        </>
                    }
                    
                    <Grid item xs={4}>
                        <FormControlLabel
                            label={t('form.purchasable')}
                            control={<Checkbox
                                color={"accent"}
                                sx={{color: theme.palette.accent.main}}
                                checked={subscription.purchasable ? stringToBool(subscription.purchasable) : false}
                                inputProps={{readOnly: true}}
                            />}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControlLabel
                            label={t('form.mobilityVoucher')}
                            control={<Checkbox
                                color={"accent"}
                                sx={{color: theme.palette.accent.main}}
                                checked={subscription.mobilityVoucher ? stringToBool(subscription.mobilityVoucher) : false}
                                inputProps={{readOnly: true}}
                            />}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControlLabel
                            label={t('form.visible')}
                            control={<Checkbox
                                color={"accent"}
                                sx={{color: theme.palette.accent.main}}
                                checked={subscription.visible ? stringToBool(subscription.visible) : false}
                                inputProps={{readOnly: true}}
                            />}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControlLabel
                            label={t('form.activable')}
                            control={<Checkbox
                                color={"accent"}
                                sx={{color: theme.palette.accent.main}}
                                checked={subscription.activable ? stringToBool(subscription.activable) : false}
                                inputProps={{readOnly: true}}
                            />}
                        />
                    </Grid>
                    {subscription.category === 'CarCloud' &&
                        <Grid item xs={4}>
                            <FormControlLabel
                                label={t('form.switchable')}
                                control={<Checkbox
                                    color={"accent"}
                                    sx={{color: theme.palette.accent.main}}
                                    checked={subscription.switchable ? stringToBool(subscription.switchable) : false}
                                    inputProps={{readOnly: true}}
                                />}
                            />
                        </Grid>
                    }
                    {(subscription.category === 'CarCloud' || subscription.category === 'BE FREE EVO') &&
                        <Grid item xs={4}>
                            <FormControlLabel
                                label={t('form.renewable')}
                                control={<Checkbox
                                    color={"accent"}
                                    sx={{color: theme.palette.accent.main}}
                                    checked={subscription.renewable ? stringToBool(subscription.renewable) : false}
                                    inputProps={{readOnly: true}}
                                />}
                            />
                        </Grid>
                    }
                    {(subscription.category === 'Car Box') &&
                        <>
                            <Grid item xs={4}>
                                <FormControlLabel
                                    label={t('form.mobilityWallet')}
                                    control={<Checkbox
                                        color={"accent"}
                                        sx={{color: theme.palette.accent.main}}
                                        checked={subscription.mobilityWallet ? stringToBool(subscription.mobilityWallet): false}
                                        inputProps={{readOnly: true}}
                                    />}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    InputProps={{readOnly: true}}
                                    label={t('form.walletIncludedDays')}
                                    value={subscription.walletIncludedDays || '-'}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    InputProps={{readOnly: true}}
                                    label={t('form.walletCalendarDays')}
                                    value={subscription.walletCalendarDays || '-'}
                                />
                            </Grid>
                            <Grid item xs={4}/>
                        </>
                    }
                    </Grid>
                    <Grid item container xs={3}>
                        {Object.keys(acrisExt).length > 0 && 
                                <Grid item xs={12} sx={{overflowY:'auto', maxHeight:'250px'}}>
                                    <AcrissMonthlyFeeTable data={acrisExt} t={t}/>  
                                </Grid>
                        }        
                    </Grid> 
                    
                </Grid>
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={onDialogClose}>{t('details.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}
export default SubscriptionDetailModal;